import React, { FunctionComponent } from 'react';
import { BlogContent, ContactForm } from 'components/containers';
import { CustomArticleSlugTypes } from 'types/global';
import { Fragment } from 'react';
import { PageWrapper } from 'components/presentional';
import { useCategories, usePages } from 'hooks';
import { useRouteTranslations } from 'utils/languages';
import { WPAcfBlog, WPAcfGlobalBlogPost } from 'types/acf';
import { WPCategory } from 'types/categories';
import { WPSimplePage } from 'types/pages';

interface OwnProps {}

type BlogPageProps = Omit<JSX.IntrinsicElements['article'], 'children'> & OwnProps;

const BlogPage: FunctionComponent<BlogPageProps> = props => {
  const BLOG_PAGE_SLUG_TYPE: CustomArticleSlugTypes = 'blog';
  const GLOBAL_PAGE_SLUG_TYPE: CustomArticleSlugTypes = 'global_blog_post';

  const { translateSlug } = useRouteTranslations();
  const { data: page, loading } = usePages<WPSimplePage<WPAcfBlog>>({ slug: translateSlug(BLOG_PAGE_SLUG_TYPE) });
  const { data: globalPage } = usePages<WPSimplePage<WPAcfGlobalBlogPost>>({ slug: translateSlug(GLOBAL_PAGE_SLUG_TYPE) });
  const { data: categories } = useCategories<WPCategory>({ per_page: 20 });

  const [customGlobalPage] = globalPage || [];
  const [customPage] = page || [];

  const renderForm = (page: WPSimplePage<WPAcfGlobalBlogPost>) => {
    const {
      acf: { newsletterForm },
    } = page || {};

    if (!newsletterForm) {
      return null;
    }

    return <ContactForm theme="white" id="newsletter-form" name="newsletter-form" data={newsletterForm} />;
  };

  return (
    <PageWrapper title={customPage?.yoast_title} meta={customPage?.yoast_meta} loading={loading} name={BLOG_PAGE_SLUG_TYPE}>
      {globalPage && customGlobalPage && (
        <Fragment>
          <BlogContent page={customGlobalPage} categories={categories?.filter(({ count }) => count > 0)} />
          {renderForm(customGlobalPage)}
        </Fragment>
      )}
    </PageWrapper>
  );
};

export default BlogPage;
